import { Component } from '@angular/core';
import { MDTagComponent } from '@melodic-ui/components';

@Component({
	selector: 'lb-beta-tag',
	template: `<md-tag type="info" size="small">Beta</md-tag>`,
	standalone: true,
	imports: [MDTagComponent]
})
export class BetaTagComponent {}
